import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, of, ReplaySubject} from "rxjs";
import {LeaveApplication, LeaveOfAbsence} from "../../../../shared/interface/employee";
import {Dictionary} from "../../../../shared/interface/dictionary";
import {
  DictService,
  LEAVE_APPLICATION_TIME_FIRST, LEAVE_APPLICATION_TIME_SECOND,
  LEAVE_APPLICATION_TYPE_CHILDCARE_LEAVE,
  LEAVE_APPLICATION_TYPE_OCCASIONAL_LEAVE,
  LEAVE_APPLICATION_TYPE_ON_DEMAND_LEAVE, LEAVE_APPLICATION_TYPE_RECEPTION,
  LEAVE_APPLICATION_TYPE_RECREATIONAL_LEAVE, WORKING_HOURS_7_16, WORKING_HOURS_7_8
} from "../../../../shared/services/dict.service";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {RegionalService} from "../../../../shared/services/regional.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {AuthService} from "../../../../shared/services/auth.service";
import {EmployeeService} from "../../../../shared/services/employee.service";
import {delay, first, takeUntil, tap} from "rxjs/operators";
import {Uuid} from "../../../../shared/interface/response/uuid";
import {HttpErrorResponse} from "@angular/common/http";
import {FileBase64} from "../../../../shared/components/file-drag-and-drop/file-drag-and-drop.component";
import {co} from "@fullcalendar/core/internal-common";
import moment from "moment";

@Component({
  selector: 'app-leave-application-edit',
  templateUrl: './leave-application-edit.component.html',
  styleUrls: ['./leave-application-edit.component.scss']
})
export class LeaveApplicationEditComponent implements OnInit,  OnDestroy, AfterViewInit  {

  @Input() leaveApplication?: Observable<LeaveApplication>;
  @Input() leaveApplicationObject?: LeaveApplication;
  @Input()  workingHoursObject?: Dictionary;
  @Output() closeModification = new EventEmitter<any>();

  holidays = [
    "2026-01-01",
    "2026-01-06",
    "2026-04-05",
    "2026-04-06",
    "2026-05-01",
    "2026-05-03",
    "2026-05-24",
    "2026-06-04",
    "2026-08-15",
    "2026-11-01",
    "2026-11-11",
    "2026-12-24",
    "2026-12-25",
    "2026-12-26",
  ];

  // wmymiar godziń dla 1/1 | 7/8 | 1/2 |3/4 etatu
  hourDimensionsv1 = [
    { value: '60', label: '1h' },
  ];
  // wmymiar godziń dla 7/8 etatu
  hourDimensionsv2 = [
    { value: '60', label: '1h' },
    { value: '90', label: '1,5 h ' },
  ];
  // wmymiar godziń dla 7/16 etatu
  hourDimensionsv3 = [
    { value: '60', label: '1h' },
    { value: '45', label: '45min' },
  ];

  readonly LEAVE_TYPES = [
    LEAVE_APPLICATION_TYPE_OCCASIONAL_LEAVE,
    LEAVE_APPLICATION_TYPE_CHILDCARE_LEAVE,
    LEAVE_APPLICATION_TYPE_ON_DEMAND_LEAVE,
    LEAVE_APPLICATION_TYPE_RECREATIONAL_LEAVE
  ];

  readonly LEAVE_TIME = [
    LEAVE_APPLICATION_TIME_FIRST,
    LEAVE_APPLICATION_TIME_SECOND
  ];


  leaveApplicationForm: FormGroup;
  formErrors: any = {};
  processingRequest = false;
  userPermissions: ReplaySubject<UserPermissions>;
  leaveOfAbsenceControl: FormControl;
  fileContentControl: FormControl;
  fileNameControl: FormControl;
  typeControl: FormControl;
  timeControl: FormControl;
  dayControl: FormControl;
  noteControl: FormControl;
  halfTmeControl: FormControl;
  startControl: FormControl;
  endControl: FormControl;
  leaveTypeControl: FormControl;
  startsAtTimeControl: FormControl;
  endAtTimeControl: FormControl;
  hourDimensionsControl: FormControl;
  leaveApplicationFormValid = false;
  leaveOfAbsence: LeaveOfAbsence;
  workingHours: Dictionary;
  half: boolean = false;
  hour: boolean = false;
  noteValid: boolean = false;
  recreational: boolean = false;
  reception: boolean = false;
  livaApplicationTime: string [] = [];
  hourDimensions: any[] = [];
  fileMaxSize = 5242880;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private leaveType: any;

  constructor(
    private regionalService: RegionalService,
    private snackBar: MatSnackBar,
    private router: Router,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private snack: MatSnackBar,
    private auth: AuthService,
    private dictService: DictService,
    private employeeService: EmployeeService
  ) {
    this.userPermissions = this.auth.getUserPermissions();
    this.leaveApplicationForm = this.fb.group({
      leaveOfAbsence: this.leaveOfAbsenceControl = fb.control('' ),
      type: this.typeControl = fb.control(''),
      time: this.timeControl = fb.control(null),
      day: this.dayControl = fb.control(1),
      note: this.noteControl = this.fb.control(''),
      halfTme: this.halfTmeControl = this.fb.control(false),
      start: this.startControl = fb.control(''),
      end: this.endControl = fb.control(''),
      half: this.leaveTypeControl = this.fb.control('full'),
      hourDimension: this.hourDimensionsControl = fb.control('', [Validators.required]),
      fileContent: this.fileContentControl = fb.control(''),
      fileName: this.fileNameControl = fb.control(''),
      startAt: this.startsAtTimeControl = fb.control('', [Validators.required]),
      endAt: this.endAtTimeControl = fb.control('', [Validators.required]),
    });
  }

  ngAfterViewInit(): void {
    if (this.leaveApplication) {
      this.leaveApplication.pipe(
        first(),
        delay(0)
      )
        .subscribe((leaveApplication: LeaveApplication) => {
          this.leaveApplicationObject = leaveApplication;
          this.initialize(leaveApplication);
        });
    } else {
      this.initialized.next(true);
    }
  }


  ngOnInit(): void {
    this.leaveApplicationForm.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
          this.leaveApplicationFormValid = this.leaveApplicationForm.valid;
        }
      );

    this.typeControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((dictId: number) => {
        this.dictService.getKey(dictId)
          .subscribe((dictKey: string) => {
            if (dictKey === LEAVE_APPLICATION_TYPE_OCCASIONAL_LEAVE){
              this.noteValid = true;
            }else {
              this.noteValid = false;
            }

            if (dictKey === LEAVE_APPLICATION_TYPE_RECREATIONAL_LEAVE || dictKey === LEAVE_APPLICATION_TYPE_CHILDCARE_LEAVE) {
              this.leaveTypeControl.enable();
            } else {
              this.leaveTypeControl.setValue('full');
              this.onSelectionChange('full');
              this.leaveTypeControl.disable();
            }

            if (dictKey === LEAVE_APPLICATION_TYPE_RECREATIONAL_LEAVE) {
              this.recreational = true;
            } else {
              this.recreational = false;
              this.leaveTypeControl.setValue('full');
              this.onSelectionChange('full');
            }

            if (dictKey === LEAVE_APPLICATION_TYPE_RECEPTION) {
              this.reception = true;
              this.endControl.setValue(this.startControl.value);
              this.endControl.disable();
            } else {
              this.reception = false;
            }
          });
      });

    this.startControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((val: any) => {
        if (this.half || this.reception){
          this.endControl.setValue(val);
        }
        this.updateLeaveDays();
      });

    this.endControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((val: any) => {
        this.updateLeaveDays();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  save(): void {
    if (this.processingRequest ){
      return;
    }
    if (!this.leaveApplicationForm.valid) {
      this.leaveApplicationForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }
    this.processingRequest = true;
    this.employeeService.sendFormAplication(this.leaveApplicationForm.getRawValue(), this.leaveApplicationObject?.uuid
    )
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        this.snackBar.open( 'Pomyślnie zaktualizowano wniosek', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.closeModification.emit();
      }, (error: HttpErrorResponse) => {

        this.snackBar.open('Podczas przesyłania formularza wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });
        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.leaveApplicationForm, this.formErrors);
          this.snack.open(error.error.error.text, error.status.toString(), {
            duration: 4000,
          });
        }
        this.processingRequest = false;

      });
  }

  cancel(): void {
    this.closeModification.emit();
  }


  onSelectionChange(value: string) {

    if (value !== 'full') {
      this.endAtTimeControl.enable();
      this.startsAtTimeControl.enable();
      this.timeControl.reset();
      this.half = true;
      this.endControl.setValue(this.startControl.value);
      this.endControl.disable();
      this.timeControl.enable();
      if (value === 'hour') {
        this.hour = true;
        this.hourDimensionsControl.enable();
      }else {
        this.hour = false;
        this.hourDimensionsControl.disable();
      }
      if (this.workingHours.key === WORKING_HOURS_7_16){
        this.hourDimensions = this.hourDimensionsv3;
      } else if  (this.workingHours.key === WORKING_HOURS_7_8)
      {
        this.hourDimensions = this.hourDimensionsv2;
      }else {
        this.hourDimensions = this.hourDimensionsv1;
      }

    }else {
      this.endAtTimeControl.disable();
      this.startsAtTimeControl.disable();
      this.half = false;
      this.hour = false;
      this.timeControl.disable();
      this.hourDimensionsControl.disable();

      this.endControl.enable();
    }
  }

  fileSelected($event: FileBase64): void {
    this.fileNameControl.setValue($event?.filename);
    this.fileContentControl.setValue($event?.base64);
  }

  initialize(leaveApplication: LeaveApplication): void {
    of(leaveApplication)
      .pipe(
        delay(0),
        tap(() => {
          this.workingHours = leaveApplication.leaveOfAbsence.employee.workingHours;
          this.leaveTypeControl.setValue(leaveApplication.minuteDimension > 0 ? 'hour' : leaveApplication.halfTime ? 'half' : 'full');
          this.onSelectionChange(this.leaveTypeControl.value );
          this.leaveApplicationForm.reset({
            leaveOfAbsence: leaveApplication.leaveOfAbsence.uuid,
            type: leaveApplication.type?.id,
            time: leaveApplication.time?.id,
            note: leaveApplication.note,
            halfTme: leaveApplication.halfTime,
            start: moment(leaveApplication.startDate),
            end: moment(leaveApplication.endDate),
            day: leaveApplication.day,
            half: leaveApplication.minuteDimension > 0 ? 'hour' : leaveApplication.halfTime ? 'half' : 'full',
            hourDimension: leaveApplication.minuteDimension.toString(),
            fileContent: '',
            fileName: '',
            startAt: leaveApplication.startAt,
            endAt: leaveApplication.endAt,
          });
        })
      ).subscribe();
  }

  countLeaveDays(start: Date | string, end: Date | string,  holidays: Set<string>): number {
    if (!start || !end) {
      return 0;
    }

    const startDate = new Date(start);
    const endDate = new Date(end);

    if (startDate > endDate) {
      return 0;
    }

    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);

    let days = 0;
    const current = new Date(startDate);

    while (current <= endDate) {
      const day = current.getDay(); // 0 = niedziela, 6 = sobota

      const dateStr =
        current.getFullYear() +
        "-" +
        String(current.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(current.getDate()).padStart(2, "0");

      const isWeekend = day === 0 || day === 6;
      const isHoliday = holidays.has(dateStr);

      if (!isWeekend && !isHoliday) {
        days++;
      }

      current.setDate(current.getDate() + 1);
    }

    return days;
  }

  updateLeaveDays(): void {
    this.dayControl.setValue( this.countLeaveDays(
      this.startControl.value,
      this.endControl.value,
      new Set(this.holidays)
    ));
  }
}
